import React from 'react';
import { observer } from 'mobx-react';
import i18n from '@tportal/login/i18n';

interface Props {
  pmInfo: any;
  isHOA: boolean;
}

const CompanyInfoFooter = (props: Props) => {
  const {
    pmInfo,
    isHOA
  } = props;

  const helpSiteLink = isHOA ? i18n.t('navigation.help_site_link.hoa') : i18n.t('navigation.help_site_link.non_hoa');

  return (
    <footer className='layout__footer bg-dark'>
      <section className='footer'>
        <p className='u-space-an'>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a>{pmInfo.name}</a>
          <br />
          <a className='u-space-an js-company-phone-number' href={`tel:${pmInfo.stripped_phone_number}`}>{pmInfo.phone_number}</a>
          <br />
          {pmInfo.website && <a href={pmInfo.website}>{i18n.t('navigation.visit_our_website')}</a>}
          {pmInfo.website && <span className='px-1'>&middot;</span>}
          <a href={helpSiteLink}>{i18n.t('navigation.help')}</a>
          <span className='px-1'>&middot;</span>
          <a href='https://www.appfolio.com/privacy'>{i18n.t('navigation.privacy')}</a>
          <span className='px-1'>&middot;</span>
          <a href='https://www.appfolio.com/terms/homeowner_tenant_portal'>{i18n.t('navigation.terms')}</a>
        </p>
      </section>
    </footer>
  );
};

export default observer(CompanyInfoFooter);
